import React from "react";
import styles from './Label.module.scss';
import PropTypes from "prop-types";

const Label = ({
  text,
  type
}) => {
  return (
    <span className={`${styles.label} ${styles[type]}`}>
      {text}
    </span>
  )
};

Label.propTypes = {
  text: PropTypes.string.isRequired,
  type: PropTypes.oneOf(['success', 'error', 'warning', 'info']).isRequired,
};

export default Label;